module.exports = __webpack_public_path__ + "static/img/COC2021-15.10765a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-15.jpg
// module id = Rv1C
// module chunks = 0